module.exports = __webpack_public_path__ + "img/answer-c3-1.0d5e9ff6.png";